<template>
  <div class="orders-service-index page-search-table" v-loading="loading">
    <div class="err-tip" v-if="badCount">有{{badCount}}个负面评价请关注</div>
    <div class="header">
      <div class="search">
        <condition-filters ref="conditionFilters" :model="currentSearch" @submit="doSearch">
          <template v-slot="scope">
            <div class="row">
              <div class="label">服务商名称</div>
              <div class="cont">
                <el-input v-model="scope.condition.serviceProviderName" size="small"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">开始时间</div>
              <div class="cont">
                <el-date-picker
                  size="small"
                  v-model="scope.condition.startTime"
                  type="datetime"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </div>
            </div>
            <div class="row">
              <div class="label">结束时间</div>
              <div class="cont">
                <el-date-picker
                  size="small"
                  v-model="scope.condition.endTime"
                  type="datetime"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </div>
            </div>
            <div class="row">
              <div class="label">订单状态</div>
              <div class="cont">
                <el-select size="small" v-model="scope.condition.status">
                  <el-option
                    v-for="item in orderStates"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="row">
              <div class="label">订单号</div>
              <div class="cont">
                <el-input v-model="scope.condition.orderCode" size="small"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">老人姓名</div>
              <div class="cont">
                <el-input v-model="scope.condition.theOldName" size="small"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">老人身份证</div>
              <div class="cont">
                <el-input v-model="scope.condition.idCard" size="small"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">老人手机号</div>
              <div class="cont">
                <el-input v-model="scope.condition.theOldPhone" size="small"></el-input>
              </div>
            </div>
          </template>
        </condition-filters>
        <el-tag
          v-if="getOrderStateName(currentSearch.status)"
          closable
          @close="currentSearch.status = undefined"
          size="small"
          type="success"
        >{{getOrderStateName(currentSearch.status)}}</el-tag>
        <el-tag
          v-if="currentSearch.orderCode"
          closable
          @close="currentSearch.orderCode = undefined"
          size="small"
          type="success"
        >{{currentSearch.orderCode}}</el-tag>
        <el-tag
          v-if="currentSearch.theOldName"
          closable
          @close="currentSearch.theOldName = undefined"
          size="small"
          type="success"
        >{{currentSearch.theOldName}}</el-tag>
        <el-tag
          v-if="currentSearch.idCard"
          closable
          @close="currentSearch.idCard = undefined"
          size="small"
          type="success"
        >{{currentSearch.idCard}}</el-tag>
        <el-tag
          v-if="currentSearch.theOldPhone"
          closable
          @close="currentSearch.theOldPhone = undefined"
          size="small"
          type="success"
        >{{currentSearch.theOldPhone}}</el-tag>
        <el-tag
          v-if="currentSearch.startTime"
          closable
          @close="currentSearch.startTime = undefined"
          size="small"
          type="success"
        >{{currentSearch.startTime}}</el-tag>
        <el-tag
          v-if="currentSearch.endTime"
          closable
          @close="currentSearch.endTime = undefined"
          size="small"
          type="success"
        >{{currentSearch.endTime}}</el-tag>
        <el-tag
          v-if="currentSearch.serviceProviderName"
          closable
          @close="currentSearch.serviceProviderName = undefined"
          size="small"
          type="success"
        >{{currentSearch.serviceProviderName}}</el-tag>
      </div>
      <div class="actions">
        <el-button size="mini" type="primary" @click="createOrder(1)">下单</el-button>
      </div>
    </div>
    <div class="statistic">
      <div>
        <div class="label">待分派</div>
        <div class="text">--</div>
      </div>
      <div>
        <div class="label">待服务</div>
        <div class="text">--</div>
      </div>
      <div>
        <div class="label">服务中</div>
        <div class="text">--</div>
      </div>
      <div>
        <div class="label">已完成</div>
        <div class="text">--</div>
      </div>
    </div>
    <el-tabs v-model="currentTab" @tab-click="onTabClick">
      <el-tab-pane v-for="item in tabs" :key="item" :label="item" :name="item"></el-tab-pane>
    </el-tabs>
    <div class="table">
      <div class="table-wrapper">
        <el-table :data="list" stripe style="width: 100%" height="100%">
          <el-table-column prop="index" label="#" align="center" width="60"></el-table-column>
          <el-table-column prop="createTime" label="下单时间" align="center" width="120"></el-table-column>
          <el-table-column prop="theOldName" label="服务对象"></el-table-column>
          <el-table-column prop="project.ServiceItemName" label="服务项目"></el-table-column>
          <el-table-column prop="serviceProviderName" label="服务商"></el-table-column>
          <el-table-column prop="project.time" label="预约开始时间" align="center" width="200"></el-table-column>
          <el-table-column prop="payment" label="金额" align="center" width="100"></el-table-column>
          <el-table-column prop="servicePersonalName" label="服务人员" width="120"></el-table-column>
          <el-table-column prop="statusName" label="服务状态" align="center" width="120">
            <template slot-scope="scope">
              <div class="cell-status">
                <span
                  :class="{'color-success-light': scope.row.status < 4}"
                >{{scope.row.statusName}}</span>
                <i
                  class="color-danger iconfont iconchaping1"
                  v-if="scope.row.evaluationStatus > 0 && scope.row.evaluationStatus < 4"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="billstatusName" label="结算状态" align="center" width="100"></el-table-column>
          <el-table-column prop="operation" label="操作" fixed="right" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="checkDetail(scope.row)">
                <i class="iconfont iconxiangqing"></i>
              </el-button>
              <el-button type="text" @click="cancelOrder(scope.row)" v-if="scope.row.status <= 3">
                <i class="iconfont iconquxiaodingdan"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination
      @size-change="loadData(1, arguments[0])"
      @current-change="loadData(arguments[0])"
      :current-page="pagination.index"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>
  </div>
</template>

<script>
import _ from 'lodash'
import ConditionFilters from '@/components/partial/ConditionFilters'
export default {
  components: { ConditionFilters },
  data() {
    return {
      currentTab: '所有数据',
      tabs: ['所有数据', '搜索结果'],
      loading: false,
      currentSearch: {},
      pagination: {
        index: 1,
        size: 20,
        total: 0
      },
      badCount: 0,
      list: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    cancelOrder(row) {
      this.modal('OrderCancelModal', row).promise.then(rst => {
        if (rst === true) {
          this.loadData(this.pagination.index, this.pagination.size)
        }
      })
    },
    checkDetail(row) {
      this.routeTo({ path: '/orders/beadhouse/detail', query: { gid: row.gid } })
    },
    onTabClick() {
      this.loadData()
    },
    doSearch(form) {
      if (_.isNil(form.status) && !form.orderCode && !form.theOldName && !form.idCard && !form.theOldPhone && !form.startTime && !form.endTime && !form.serviceProviderName) {
        this.$message.error('请至少选择或者输入一个搜索条件')
        return
      }
      this.$refs.conditionFilters.close()
      this.$set(this.currentSearch, 'status', form.status)
      this.$set(this.currentSearch, 'orderCode', form.orderCode)
      this.$set(this.currentSearch, 'theOldName', form.theOldName)
      this.$set(this.currentSearch, 'idCard', form.idCard)
      this.$set(this.currentSearch, 'theOldPhone', form.theOldPhone)
      this.$set(this.currentSearch, 'startTime', form.startTime)
      this.$set(this.currentSearch, 'endTime', form.endTime)
      this.$set(this.currentSearch, 'serviceProviderName', form.serviceProviderName)
      this.currentTab = this.tabs[1]
    },
    loadData(pageIndex, pageSize) {
      this.badCount = 0
      if (this.closeBadTipHandler) {
        clearTimeout(this.closeBadTipHandler)
      }
      pageIndex = (pageIndex || 1) - 1
      let query = { index: pageIndex || 0, size: pageSize || this.pagination.size, orderType: 4 }
      if (this.currentTab === '搜索结果') {
        query = { ...query, ...this.currentSearch }
        if (this.Utils.isObjectEmpty(this.currentSearch)) {
          this.list = []
          this.pagination.index = 1
          this.pagination.total = 0
          return
        }
      }
      this.loading = true
      this.Service.call('order', 'GET', query).then(data => {
        this.pagination = {
          index: data.index + 1,
          size: data.size,
          total: data.total
        }
        let list = data.data || []
        let badCount = 0
        _.forEach(list, (item, idx) => {
          item.index = idx + 1 + 20*(this.pagination.index-1);
          item.createTime = this.Utils.dateFormat(item.createTime, 'MM-DD HH:mm')
          let project = {}
          try {
            project = JSON.parse(item.serviceItemSkuInfos)
            project = project && project.length && project[0]
            let remarks = (project.Remark || '').split(',')
            if (remarks && remarks.length) {
              project.time = remarks[0] + (remarks[1] ? ' ' + remarks[1] : '')
            }
          } catch (e) { }
          item.project = project
          item.statusName = this.getOrderStateName(item.status) || '-'
          item.billstatusName = item.billStatus ? '已结算' : '未结算'
          if (item.evaluationStatus >= 1 && item.evaluationStatus <= 4) {
            badCount++
          }
        })
        this.list = list
        this.badCount = badCount
        this.closeBadTipHandler = setTimeout(() => {
          this.badCount = 0
        }, 2000)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    currentSearch: {
      deep: true,
      handler() {
        if (this.Utils.isObjectEmpty(this.currentSearch)) {
          this.currentTab = this.tabs[0]
        } else {
          this.currentTab = this.tabs[1]
        }
        this.loadData()
      }
    }
  }
}
</script>
